<template>
    <div 
        class="formfield" 
        :class="{'formfield--error': (error)}">
        <label
            v-if="label"
            class="formfield__label">{{ label }}</label>
        <div class="formfield__input formfield__voucher">
            <div class="formfield__voucher__inner">
                <div
                    v-for="index in 6"
                    :key="index">
                    <input
                        type="text"
                        placeholder="-"
                        maxlength="1"
                        v-model="code[index - 1]"
                        @focus="removeError()"
                        @keyup="checkNextField(index - 1)" >
                </div>
            </div>

            <div 
                class="formfield__error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    $_veeValidate: {
        value () {
            return this.code;
        }
    },
    data() {
        return {
            code: []
        };
    },
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'text',
        },
        errors: {
            type: Object,
            default: null,
        },
    },
    computed: {
        error() {
            if(this.errors) {
                return this.errors.first(this.name);
            }
        },
        inputType() {
            return this.type || 'text';
        },
    },
    watch: {
        code() {
            this.updateValue();
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.code.join(''));
        },
        checkNextField(index) {
            const $currentElement = this.$el.querySelectorAll('.formfield__voucher__inner input')[index]
            const value = $currentElement.value;

            if(!value) {
                return;
            }
            
            $currentElement.value = $currentElement.value.substr(0, 1);

            if(value === ' ') {
                $currentElement.value = '';
            } else if(value.length > 0) {
                const $nextElement = this.$el.querySelectorAll('.formfield__voucher__inner input')[index + 1];

                if($nextElement && $nextElement.value == '') {
                    $nextElement.focus();
                }    
            }
        },
        removeError() {
            if(this.errors) {
                this.errors.remove(this.name);
            }
        },
    },
};
</script>
